import { Button, Input } from "@minervaproject/fds";
import clsx from "clsx";
import { formatISO, isValid } from "date-fns";

import { useAppDispatch, useAppSelector, useArraySelector } from "hooks/redux_hooks";
import { getClassEndTime, getClassStartTime } from "shared/utils/monitoring";
import {
  setEndTimeFilter,
  setStartTimeFilter,
  setTimeFilter,
} from "store/reducers/local_monitoring";
import { selectClassInfo } from "store/selectors/classroom";
import { selectTimeFilter } from "store/selectors/local_monitoring";

function TimeFilter() {
  const dispatch = useAppDispatch();

  const classInfo = useAppSelector(selectClassInfo());
  const classStartTime = getClassStartTime(classInfo);
  const classEndTime = getClassEndTime(classInfo);

  const [startTimeFilter, endTimeFilter] = useArraySelector(selectTimeFilter());

  const startTimeDate = new Date(startTimeFilter);
  const endTimeDate = new Date(endTimeFilter);

  const onClassEventsClick = () => {
    if (!classStartTime || !classEndTime) return;
    dispatch(
      setTimeFilter({
        startTimeFilter: formatISO(classStartTime),
        endTimeFilter: formatISO(classEndTime),
      }),
    );
  };

  const onAllEventsClick = () => {
    dispatch(
      setTimeFilter({
        startTimeFilter: "",
        endTimeFilter: "",
      }),
    );
  };

  return (
    <div style={{ margin: "8px auto 0", width: "1006px", border: "2px solid steelblue" }}>
      <div className="my2 center body-s">
        Filter monitoring events by time range. Leave blank to show all events. This will affect all
        data/tables on this page.
      </div>
      <div className="mx2">
        <Input
          className={clsx("m2", {
            "outline-2-red": startTimeFilter && !isValid(startTimeDate),
          })}
          type="text"
          placeholder="From (e.g. 7/8/19 00:53)"
          size="lg"
          onChange={(value: string) => {
            dispatch(setStartTimeFilter(value));
          }}
          value={startTimeFilter}
        />
        <Input
          className={clsx("m2", { "outline-2-red": endTimeFilter && !isValid(endTimeDate) })}
          type="text"
          placeholder="To (e.g. 7/8/19 00:55)"
          size="lg"
          onChange={(value: string) => {
            dispatch(setEndTimeFilter(value));
          }}
          value={endTimeFilter}
        />
        <Button className="m2" onClick={onClassEventsClick} width="180px">
          In-Class Events
        </Button>
        <Button className="m2" onClick={onAllEventsClick} width="180px">
          All Events
        </Button>
      </div>
    </div>
  );
}

export { TimeFilter };
